<template>
  <div id="footer" class="acea-row row-middle">
    <router-link
      :to="item.url"
      class="item"
      :class="{ on: item.url === $route.path }"
      v-for="(item, index) in footerList"
      :key="index"
    >
      <div
        class="iconfont"
        :class="item.icon1 + ' ' + (item.url === $route.path ? item.icon2 : '')"
      ></div>
      <div>{{ item.name }}</div>
    </router-link>
  </div>
</template>
<script>
import { getUser, getMenuUser } from "@api/user";
export default {
  name: "Footer",
  props: {},
  data: function() {
    return {
      footerList: []
    };
  },
  mounted: function() {
    this.User();
  },
  methods: {
	  User:function() {
	    let that = this;
	    getUser().then(res => {
			that.footerList=[
				 {
				   name: "首页",
				   icon1: "icon-shouye-xianxing",
				   icon2: "icon-shouye",
				   url: "/"
				 },
				 {
				   name: "分类",
				   icon1: "icon-yingyongchengxu-xianxing",
				   icon2: "icon-yingyongchengxu",
				   url: "/category"
				 },
				 {
				   name: "购物车",
				   icon1: "icon-caigou-xianxing",
				   icon2: "icon-caigou",
				   url: "/cart"
				 },
				 {
				   name: "我的",
				   icon1: "icon-yonghu-xianxing",
				   icon2: "icon-yonghu",
				   url: "/user"
				 },
			] 
		  // if(res.data.now_money%500 == 0){
			 //  that.footerList=[
				//   {
				//     name: "首页",
				//     icon1: "icon-shouye-xianxing",
				//     icon2: "icon-shouye",
				//     url: "/"
				//   },
				//   {
				//     name: "购物车",
				//     icon1: "icon-caigou-xianxing",
				//     icon2: "icon-caigou",
				//     url: "/cart"
				//   },
				//   {
				//     name: "我的",
				//     icon1: "icon-yonghu-xianxing",
				//     icon2: "icon-yonghu",
				//     url: "/user"
				//   },
			 //  ]
		  // }else{
			 // that.footerList=[
				//  {
				//    name: "首页",
				//    icon1: "icon-shouye-xianxing",
				//    icon2: "icon-shouye",
				//    url: "/"
				//  },
				//  {
				//    name: "分类",
				//    icon1: "icon-yingyongchengxu-xianxing",
				//    icon2: "icon-yingyongchengxu",
				//    url: "/category"
				//  },
				//  {
				//    name: "购物车",
				//    icon1: "icon-caigou-xianxing",
				//    icon2: "icon-caigou",
				//    url: "/cart"
				//  },
				//  {
				//    name: "我的",
				//    icon1: "icon-yonghu-xianxing",
				//    icon2: "icon-yonghu",
				//    url: "/user"
				//  },
			 // ] 
		  // }
	      
	      
	    });
	  }
  }
};
</script>
